import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from '../../models/user';
import { LoggingService } from '../../services/logging.service';
import { userRequest } from '../../models/userRequest';
import { Subscription } from 'rxjs';
import { ManagerDashboardService } from '../../services/manager-dashboard.service';
import { Team } from '../../models/team';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-user',
  standalone: false,
  templateUrl: './add-user.component.html',
  styleUrl: './add-user.component.scss'
})
export class AddUserComponent implements OnInit, OnDestroy {
  @Input() teamId!: number;
  userForm !: FormGroup;
  managerId !: number;
  teamSubscription !: Subscription;
  teams : Team[] = [];
  userSubscription !: Subscription;

  constructor(private fb: FormBuilder, private loggingService : LoggingService, 
              private managerDashboardService : ManagerDashboardService,
              private router : Router) {}

  buildUserForm() {
    this.userForm = this.fb.group({
      Email: ['', Validators.required],
      name: ['', Validators.required],
      IsActive: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.buildUserForm();
    this.loggingService.logDebug("Getting the managerId from session storage");
    const managerid = sessionStorage.getItem('manager_id');
    if(managerid) {
      this.managerId = parseInt(managerid, 10);
    }
    this.teamSubscription = this.managerDashboardService.getAllTeams(this.managerId).subscribe(
      (teams) => {
        this.teams = teams;
      }
    );
  }

onSubmit(event: Event) {
  event.preventDefault();

  const form = event.target as HTMLFormElement;

  if (!form.checkValidity()) {
    form.reportValidity(); // Browser shows default error messages
    return;
  }

    if (this.userForm.invalid) {
    this.userForm.markAllAsTouched();
    return;
  }

   const user: userRequest = { ...this.userForm.value };
  user.managerID = this.managerId;
  user.personType = "user";
  user.teamID = this.teamId;
  user.RoleID = 1;

  this.userSubscription = this.managerDashboardService.createUser(user).subscribe((user) => {
    this.userAdded.emit(user);
    form.reset(); 
  });
}


  ngOnDestroy() {
    this.teamSubscription.unsubscribe();
    if(this.userSubscription){
      this.userSubscription.unsubscribe();
    }
    
  }

    @Output() userAdded = new EventEmitter<User>();

}
